import TimetableSerializer from './base';

export default class Period extends TimetableSerializer {}
